var aHref = location.href.split('/');
$.ajax({
    url: 'https://api.db-ip.com/v2/free/self',
    type: 'GET',
    dataType: 'json',
    success: function (r) {
        var aHref = location.href.split('/');
        let oAllowedContry = {
          'Oman' : 'OM',
          'United Arab Emirates' : 'AE',
          'Bahrain' : 'BH',
          'Saudi Arabia' : 'SA',
          'India' : 'IN',
          'Kenya' : 'KE'
        };
        if (Object.values(oAllowedContry).includes(r.countryCode) && aHref[aHref.length -1] == 'access-denied') {
           // window.location.href = 'https://armaf.ae/';
        }else if((!Object.values(oAllowedContry).includes(r.countryCode)) && (aHref[aHref.length -1] != 'access-denied')){
          //  window.location.href = 'https://armaf.ae/pages/access-denied';
        } 
    }
})